import React from "react";

const IconClose = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22">
            <path
                fill="#242D52"
                fill-rule="evenodd"
                d="M17.925.747l2.828 2.828L13.328 11l7.425 7.425-2.828 2.828-7.425-7.425-7.425 7.425-2.828-2.828L7.671 11 .247 3.575 3.075.747 10.5 8.171 17.925.747z"
            />
        </svg>
    );
};

export default IconClose;
